import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AddContact, CRMModals, BaseButton, BaseStaticSelect, SearchBar } from 'crm/_components';
import { useContactsFilters } from '../ContactsFilters/ContactsFiltersContext';
import { staticStyles } from './style';

const ActionsTab = () => {
  const [crmModalType, setCrmModalType] = useState(null);
  const [addContact, setAddContact] = useState(false);
  const { intl, params, replace } = useContactsFilters();
  const selected = useSelector(state => state.crm.contacts.selectedContactsIds);
  const actionOptions = ['justReassign', 'reassignManager', 'setPartnerCode', 'saveAs'].map((id, index) => ({
    label: intl.formatMessage({ id }),
    value: ['reassign', 'reassignManager', 'setPartnerCode', 'saveAs'][index],
  }));
  return (
    <div className="ActionsTab">
      <div className="ActionsTab__filters-left">
        <BaseStaticSelect
          labelTextId="justActions"
          options={actionOptions}
          onSelect={setCrmModalType}
          isDisabled={!selected.length}
        />
        <SearchBar
          key={params.search || ''}
          initValue={params.search || ''}
          onChange={value => replace({ ...params, search: value || undefined, page: 1 })}
        />
      </div>
      <BaseButton textId="justUploadContacts" onClick={() => setAddContact(true)} plus />
      <AddContact isOpen={addContact} onRequestClose={() => setAddContact(false)} />
      {crmModalType && <CRMModals modalType={crmModalType} onRequestClose={() => setCrmModalType(null)} />}
      <style jsx>{staticStyles}</style>
    </div>
  );
};

export default ActionsTab;
